import React from 'react';

import EditorFormik from '~/components/communications/EmailCommunicationCard/EmailEditor/EditorFormik';
import type { DisplayConfigProps } from '~/components/core/Editor/types';
import Text from '~/components/core/TextComponents/Text';
import type { TemplateBuilderEditorInnerComponentProps } from '~/components/GenericTemplates/types';
import { TEMPLATE_BUILDER_FORM_KEYS } from '~/components/GenericTemplates/utils/genericTemplatesUtils';

type CustomDisplayConfig = Omit<DisplayConfigProps, 'suggestions'>;

const BaseGenericTemplatesEditor: React.FC<
  TemplateBuilderEditorInnerComponentProps & {
    titleHeading: string;
    bodyHeading: string;
    titleFormatDisplayConfig?: CustomDisplayConfig;
    bodyFormatDisplayConfig?: CustomDisplayConfig;
  }
> = ({
  disabled,
  titleHeading,
  bodyHeading,
  suggestions,
  titleFormatDisplayConfig = {},
  bodyFormatDisplayConfig = {},
}) => {
  return (
    <div className="my-16">
      <div className="my-16">
        <Text variant={Text.VARIANTS.SM} className="my-12">
          {titleHeading}
        </Text>
        <EditorFormik
          id={TEMPLATE_BUILDER_FORM_KEYS.TITLE_TEMPLATE}
          classNameEditor="overflow-auto"
          disabled={disabled}
          autoFocus
          displayConfig={{ ...titleFormatDisplayConfig, suggestions: !!suggestions }}
          suggestionOptions={suggestions}
        />
      </div>
      <div className="my-16">
        <Text variant={Text.VARIANTS.SM} className="my-12">
          {bodyHeading}
        </Text>
        <EditorFormik
          id={TEMPLATE_BUILDER_FORM_KEYS.BODY_TEMPLATE}
          classNameEditor="min-h-[150px] overflow-auto"
          disabled={disabled}
          autoFocus
          displayConfig={{
            ...bodyFormatDisplayConfig,
            suggestions: !!suggestions,
            // Always on, so a stored section keeps its wrapper when the flag is off: without the node
            // the editor drops the wrapper, and the next save makes the section text unconditional.
            conditionalSections: true,
          }}
          suggestionOptions={suggestions}
        />
      </div>
    </div>
  );
};

export default BaseGenericTemplatesEditor;
